import { api } from '../../../config';
import { showToaster } from '../../../helpers/toastrMessgaes/showToaster';
import { updatePrecautionMutation as mutation } from '../../../lib/graphql';

const updatePrecautionNotification = ({ id, title, description, isEnabled, imageName }) => {

    return async (dispatch, getState, { client }) => {
        try {
            const { data } = await client.mutate({
                mutation,
                variables: {
                    id,
                    title,
                    description,
                    isEnabled: isEnabled === 'true',
                    imageName
                }
            });

            if (data?.updatePrecautionNotification?.status == 200) {
                showToaster({ messageId: 'changesUpdated', toasterType: 'success' });
            } else {
                showToaster({ messageId: 'errorMessage', requestContent: { content: data?.updatePrecautionNotification?.errorMessage }, toasterType: 'error' });
            }
        }
        catch (error) {
            showToaster({ messageId: 'catchMessage', requestContent: { content: error }, toasterType: 'error' });
        }
    };
}

const removeStaticBannerImage = async (fileName) => {
    try {
        const url = api.apiEndpoint + "/deleteStaticBannerImage";
        const resp = await fetch(url, {
            method: 'post',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ fileName }),
        });

        const { status } = await resp.json();

        if (status) {
            return {
                status
            };
        }

    } catch (err) {
        showToaster({ messageId: 'catchMessage', requestContent: { content: err }, toasterType: 'error' });
    }
}

export {
    updatePrecautionNotification,
    removeStaticBannerImage
};